import { gql } from '__generated__/gql';

/**
 * Shared by the accreditation page and the document slide-over's accreditation
 * confirmation dialog.
 */
export const UPSERT_ACCREDITATION_APPLICATION_MUTATION = gql(`
  mutation UpsertAccreditationApplication(
    $investmentEntityId: ID!
    $accreditationStatus: AccreditationStatusEnumType!
    $accreditationProofDocument: Upload
    $accreditationEligibilityCriteria: [AccreditationEligibilityCriteriaEnumType!]
  ) {
    upsertAccreditationApplication(
      investmentEntityId: $investmentEntityId
      accreditationStatus: $accreditationStatus
      accreditationProofDocument: $accreditationProofDocument
      accreditationEligibilityCriteria: $accreditationEligibilityCriteria
    ) {
      id
      accreditationStatus
      accreditationFlow
      accreditationProofDocument {
        url
        name
      }
      accreditationEligibilityCriteria
    }
  }
`);
